// HEADER //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

var kviq = {} // Namespace

kviq.pathname_full = window.location.href;
kviq.pathname_path = window.location.pathname;
kviq.net_id = '2201';
kviq.zindex_counter = 1;
kviq.cookie_main = 'K2bf0aWdPvzpf4sT51R5wG42J3QMARwP';
kviq.page_url = '';
//document.getElementsByTagName('html')[0].style.fontSize = 'inherit';

// COMMON METHODS (super) //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

kviq.ajax = function (url, parameters, callback, id) {
  var httpRequest; // create our XMLHttpRequest object
  if (window.XMLHttpRequest) {
    httpRequest = new XMLHttpRequest();
  } else if (window.ActiveXObject) {
    // Internet Explorer is stupid
    httpRequest = new
    ActiveXObject("Microsoft.XMLHTTP");
  }

  httpRequest.onreadystatechange = function () {
    // inline function to check the status of our request, this is called on every state change
    if (this.readyState === 4 && this.status === 200) {
      callback(id, this);
      // call the callback function
    }
  };

  httpRequest.open("POST", url, true);
  httpRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  httpRequest.send(parameters);
}

kviq.set_cookie = function (c_name, value, exdays, path) {
  var expires = new Date();
  expires.setTime(expires.getTime() + (exdays * 86400000));
  var c_value = escape(value);
  if (exdays !== null) {
    c_value = c_value + "; expires=" + expires.toUTCString();
  }
  if (path !== null) {
    c_value = c_value + "; path=" + path;
  }
  document.cookie = c_name + "=" + c_value;
}

kviq.get_cookie = function (c_name) {
  var i, x, y, ARRcookies = document.cookie.split(";");
  for (i = 0; i < ARRcookies.length; i++) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
    x = x.replace(/^\s+|\s+$/g, "");
    if (x == c_name) {
      return unescape(y);
    }
  }
}

kviq.find_highest_zindex = function (e) {
  var elems = document.getElementsByTagName(e);
  var highest = 0;
  for (var i = 0; i < elems.length; i++) {
    var zIndex = document.defaultView.getComputedStyle(elems[i], null).getPropertyValue("z-index");
    if ((zIndex > highest) && (zIndex != 'auto')) {
      highest = zIndex;
    }
  }
  kviq.zindex_counter++;
  return parseInt(highest) + kviq.zindex_counter;
}

kviq.add_container = function (container) {
  var parser = new DOMParser();
  var html = parser.parseFromString(container, 'text/html');
  document.body.appendChild(html.body.firstChild);
}

kviq.close_container = function (type) {
  var container;
  if (type == 'ts' || type == 'sf') {
    container = document.getElementById('_kviq_' + type + '-container');
  } else {
    container = document.getElementById('_kviq_ot-container');
  }
  container.parentNode.removeChild(container);
  if (document.getElementById('_kviq_ot-returners')) {
    top.window.location.href = document.getElementById('_kviq_ot-returners').name;
  }
}

kviq.info_popupbox = function (head, body) {
  var info = '<div id="_kviq_info-popup" style="font-family: \'Open Sans\', sans-serif; font-size: 20px; background-color: #ffffff; border: 2px solid #1E1E59; padding: 10px 15px 15px 15px; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); border-radius: 2px; color: #272776"><h5 style="font-size: 22px; margin: 0px 24px 5px 0px;">' + head + '</h5><span style="cursor: pointer; float: right; position: absolute; top: 0px; right: 0px; padding: 10px 15px 5px 0px;" onClick="var e = this.parentNode; e.parentNode.removeChild(e);">&#9747;</span>' + body + '</div>';
  kviq.add_container(info);
  document.getElementById('_kviq_info-popup').style.zIndex = kviq.find_highest_zindex("*");

}

kviq.adjust_div = function (type) {
  // Adjust if small screens
  var d = document.getElementById('_kviq_' + type + '-div-i');
  if (d) {
    if (d.offsetHeight < window.innerHeight) {
      d.parentNode.style.top = Math.round((window.innerHeight - d.offsetHeight) / 2) + "px";
      d.parentNode.style.top = (d.parentNode.style.top.replace(/[a-z]/g, '') > 150 ? '150px' : d.parentNode.style.top);
    } else {
      d.style.top = "5px";
    }
  }
}
kviq.adjust_img_div = function (form) {
  var imgs = form.getElementsByTagName('img');
  for (var i = 0; i < imgs.length; i++) {
    imgs[i].parentNode.style.height = 'auto';
  }
}

kviq.gen_token = function (length) {
  var code = '';
  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < length; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
}

kviq.images_refresh = function () {
  var images = document.getElementsByTagName('img');
  for (var i = 0; i < images.length; i++) {
    var dt = new Date();
    var img = images[i];
    if (img.src.length >= 0) {
      img.src = img.src + (img.src.match(/\?/) ? '&' : '?') + dt.getTime();
    }
  }
}

kviq.mobilecheck = function () {
  var check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

kviq.content_control = function (block) {
  if (typeof block == 'undefined') {
    block = kviq.content_block;
  }
  if (block == true) {
    kviq.html.style.display = "none";
    kviq.html.style.visibility = "hidden";

    if (typeof document.onselectstart != "undefined") {
      document.onselectstart = new Function("return false");
    } else {
      document.onmousedown = new Function("return false");
      document.onmouseup = new Function("return false");
    }

  } else {
    kviq.html.style.display = "block";
    kviq.html.style.visibility = "visible";
  }
}

kviq.get_url_parameters = function (url) {
  var params = {};
  var parser = document.createElement('a');
  parser.href = url;
  var query = parser.search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (pair[0].length > 0) {
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
  }
  return params;
}

kviq.autoclick = function (id) {
//    var a = $(id)[0];
  var a = document.getElementById(id);
  var evObj = document.createEvent('MouseEvents');
  evObj.initMouseEvent('click', true, true, window);
  a.dispatchEvent(evObj);
}
// connect_pay.js - shopify [ 2201 ] //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

kviq.msn = '';
kviq.oid = '';
kviq.ext_productid = '';
kviq.heartbeat_handle = 0;
kviq.heartbeat_counter = 0;
kviq.heartbeat_looplimit = 300;
var kviq_checkout_button = false;
var kviq_checkout_br = false;
var kviq_autobuy = false;
var kviq_is_cart = false;
var kviq_is_app = false;

if (kviq.oid == '' && window.location.search.match(/_kviqti=([A-Za-z0-9\-]+)/g)) {
  var match = window.location.search.match(/_kviqti=[A-Za-z0-9\-]+/g);
  var parts = match[0].substring(8).split('-');
  kviq.cookie_main = parts[0];
  kviq.oid = parts[1];
}

kviq._2201sf = function () {

  window.addEventListener('load', function () {

    kviq.gen_checkout_button(1);

    if (window.location.hash) {
      var hash = window.location.hash.substring(1);
      if (hash == 'autobuy') {
        kviq_autobuy = true;
      }
    }
  });

  window.addEventListener('change', function () {
    kviq.gen_checkout_button(1);
  });

  kviq.getClickedVippsButton = function (target) {
    if (target.id === '_kviq_ec') {
      return target;
    }
    if (target.parentNode && target.parentNode.id === '_kviq_ec') {
      return target.parentNode;
    }
    return null;
  };

  kviq.findFormForButton = function (button) {
    var parent = button.parentNode;
    
    while (parent) {
      if (parent.tagName === 'FORM') {
        return parent;
      }
      parent = parent.parentNode;
    }
    
    return null;
  };

  kviq.disableVippsButton = function (button) {
    if (!button) return;
    
    button.setAttribute('id', '');
    button.style.cursor = 'wait';
    button.disabled = true;
    
    setTimeout(function () {
      button.style.cursor = 'auto';
      button.setAttribute('id', '_kviq_ec');
      button.disabled = false;
    }, 5000);
  };

  kviq.handleVippsCheckout = function (button, form, formType) {
    var parameters = false;
    var quantity = 0;
    
    if (formType === 'cart_page' || formType === 'cart_drawer') {
      var productid_variantids = [];
      
      if (window.saso && window.saso.cart) {
        console.log('[kviq.js] Using saso.cart', window.saso.cart);
        window.saso.cart.items.forEach(function (element) {
          productid_variantids.push(element.product_id + '|' + element.variant_id + '|' + element.quantity);
        });
      } else if (window.swymCart && window.swymCart.items) {
        console.log('[kviq.js] Using swymCart', window.swymCart);
        window.swymCart.items.forEach(function (cartItem) {
          productid_variantids.push(cartItem.product_id + '|' + cartItem.variant_id + '|' + cartItem.quantity);
        });
      } else {
        var inputs = form.getElementsByTagName('INPUT');
        for (var x = 0; x < inputs.length; x++) {
          if ((inputs[x].getAttribute('type') === 'text' || inputs[x].getAttribute('type') === 'number') && 
              inputs[x].getAttribute('id') && inputs[x].getAttribute('id').match(/^updates_/i)) {
            var match = inputs[x].getAttribute('id').match(/^(updates_|updates_[a-z]+_)([0-9]+):/i);
            if (match) {
              var variantid = match[2];
              var quantity = inputs[x].value;
              var productid = 0;
              productid_variantids.push(productid + '|' + variantid + '|' + (quantity < 1 ? 1 : quantity));
            }
          }
        }
      }

      console.log('[kviq.js] Cart items:', productid_variantids);

      if (productid_variantids.length > 0) {
        kviq_is_app = (kviq.mobilecheck() && !kviq_is_app ? true : false);
        parameters = "nid=" + kviq.net_id + "&prs=" + encodeURI(productid_variantids.join(',')) + "&token_i=" + kviq.cookie_main + "&url=" + encodeURI(window.location.href) + "&is_app=" + kviq_is_app;

        kviq.ajax('/cart/clear.js', '', kviq.submit_response, 90);
      }

    } else if (formType === 'product') {
      var selects = form.getElementsByTagName('SELECT');
      for (var x = 0; x < selects.length; x++) {
        if (selects[x].name === 'id') {
          var productid = '';
          if (form.getAttribute('id')) {
            productid = form.getAttribute('id').replace(/^.*_/g, '');
          }
          
          var variantid = selects[x].value;
          
          if (!productid || !productid.match(/^[0-9]{4,64}$/)) {
            if (typeof meta !== 'undefined' && meta.product && meta.product.id) {
              productid = meta.product.id;
            }
          }
          
          kviq.variant_id = variantid;

          var inputs = form.getElementsByTagName('INPUT');
          for (var y = 0; y < inputs.length; y++) {
            if (inputs[y].name === 'quantity') {
              quantity = parseInt(inputs[y].value);
            }
          }
          
          var productid_variantid = productid + '|' + variantid + '|' + (quantity < 1 ? 1 : quantity);

          kviq_is_app = (kviq.mobilecheck() && !kviq_is_app ? true : false);
          parameters = "nid=" + kviq.net_id + "&prs=" + encodeURI(productid_variantid) + "&token_i=" + kviq.cookie_main + "&url=" + encodeURI(window.location.href) + "&is_app=" + kviq_is_app;
        }
      }
    }

    if (parameters) {
      var url = "https://s.kviq.no/sf/x";
      kviq.ajax(url, parameters, kviq.submit_response, 2);
    }
  };

  window.addEventListener('click', function (e) {
    var clickedButton = kviq.getClickedVippsButton(e.target);
    if (clickedButton) {
      e.preventDefault();
      e.stopPropagation();
      var clickedButtonType = clickedButton.getAttribute('data-kviq-type');
      console.log('[kviq.js] Vipps button clicked', {
        id: clickedButton.id,
        clickedButtonType,
      });

      var addToCartWrapper = document.querySelector('.add-to-cart-wrapper');
      var numAvailableVariants = addToCartWrapper ? parseInt(addToCartWrapper.getAttribute("data-num-available-variants")) : null;

      if (numAvailableVariants > 1 && clickedButtonType === 'product') {
        console.log('[kviq.js] Multiple variants detected, opening variant selector');
        window.dropdownTriggeredFromVippsBtn = true;
        var variantSelect = document.querySelector('.custom-variant-select');
        var variantSelectIsActive = variantSelect?.classList?.contains('active');
        if (variantSelect && !variantSelectIsActive) {
          variantSelect.click();
        }
        return;
      }

      kviq.disableVippsButton(clickedButton);

      var form = kviq.findFormForButton(clickedButton);
      
      if (!form) {
        console.log('[kviq.js] No form found for button');
        return;
      }

      var formType = kviq.getFormType(form);
      
      console.log('[kviq.js] Processing checkout for form type:', formType);

      kviq.handleVippsCheckout(clickedButton, form, formType);
    } else {
      // kviq.gen_checkout_button(1);
    }
  });

  window.addEventListener('keyup', function (e) {
    if (e.target.id !== undefined && e.target.id == 'kviq.zipcode') {
      if (document.getElementById('kviq.zipcode').value.match(/^[0-9]{4}$/)) {
        var url = "https://s.kviq.no/ts/z";
        var parameters = "zipcode=" + document.getElementById('kviq.zipcode').value;
        kviq.ajax(url, parameters, kviq.submit_response, 16);
      } else {
        document.getElementById('kviq.place').value = '';
      }
    }
  });

  window.addEventListener('resize', function () {
    // Adjust small screens
    kviq.adjust_div('sf');
  });

  // Heartbeat
  if (kviq.oid != '') {
    kviq.heartbeat_sf(kviq.oid);
    kviq.heartbeat_handle = setInterval(function () {
      kviq.heartbeat_sf(kviq.oid);
    }, 1000);
  }

  kviq.vipps_buttons = {};

  kviq.getFormType = function (form) {
    var formAction = form.getAttribute('action') || '';
    var formId = form.getAttribute('id') || '';
    var formDataLocation = form.getAttribute('data-location') || '';
    
    var actionWithoutQuery = formAction.split('?')[0];
    
    var isInDrawer = false;
    var parent = form.parentNode;
    
    if (formId.match(/drawer/i) || formDataLocation.match(/drawer/i)) {
      isInDrawer = true;
    }
    
    while (parent && !isInDrawer) {
      var parentClass = parent.className || '';
      var parentId = parent.id || '';
      
      if (parentClass.match(/(drawer|cart-drawer|mini-cart|side-cart)/i) || 
          parentId.match(/(drawer|cart-drawer|mini-cart|side-cart|CartDrawer)/i)) {
        isInDrawer = true;
        break;
      }
      parent = parent.parentNode;
    }
    
    if (actionWithoutQuery === '/cart/add') {
      return 'product';
    } else if (actionWithoutQuery === '/cart' || actionWithoutQuery.match(/\/cart$/)) {
      return isInDrawer ? 'cart_drawer' : 'cart_page';
    }
    
    return null;
  };

  kviq.getFormIdentifier = function (form) {
    var formType = kviq.getFormType(form);
    
    if (formType === 'product') {
      var formId = form.getAttribute('id') || form.getAttribute('data-product-id');
      return 'product_' + (formId || 'default');
    } else if (formType === 'cart_drawer') {
      console.log('[kviq.js] Found cart drawer form, skipping now');
      return;
      // return 'cart_drawer';
    } else if (formType === 'cart_page') {
      return 'cart_page';
    }
    
    return null;
  };

  kviq.findAllTargetForms = function () {
    var forms = document.getElementsByTagName('FORM');
    var targetForms = [];
    
    for (var i = 0; i < forms.length; i++) {
      var formAction = forms[i].getAttribute('action') || '';
      var formMethod = forms[i].method;
      
      if (formMethod !== 'post') {
        continue;
      }
      
      var actionWithoutQuery = formAction.split('?')[0];
      
      var isCartAdd = actionWithoutQuery === '/cart/add' && forms[i].getElementsByTagName('BUTTON')[0];
      var isCart = actionWithoutQuery === '/cart' || actionWithoutQuery.match(/\/cart$/);
      
      if (isCartAdd || isCart) {
        var formIdentifier = kviq.getFormIdentifier(forms[i]);
        if (formIdentifier) {
          targetForms.push({
            form: forms[i],
            type: kviq.getFormType(forms[i]),
            identifier: formIdentifier
          });
        }
      }
    }
    
    return targetForms;
  };

  kviq.findTargetButton = function (form, formType) {
        var buttons = form.getElementsByTagName('BUTTON');
    
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      
      if (button.id === '_kviq_ec' || button.disabled) {
        continue;
      }
      
      var buttonType = button.getAttribute('type');
      var buttonName = button.name;
      var buttonId = button.id;
      var buttonClass = button.className;
      
      var isCheckoutButton = buttonType === 'submit' && buttonName === 'checkout';
      if (isCheckoutButton && (formType === 'cart_page' || formType === 'cart_drawer')) {
              kviq_is_cart = true;
        return button;
      }
      
      var isAddToCartSubmit = buttonType === 'submit' && 
                             (buttonName === 'add' || buttonClass.match(/(add\-to\-cart|productForm\-submit|cart\-submit)/i));
      if (isAddToCartSubmit) {
        return button;
      }
      
      var isAddToCartButton = buttonType === 'button' && 
                             (buttonId === 'add-to-cart' || buttonName === 'add' || buttonClass.match(/(cart\-submit)/i));
      if (isAddToCartButton) {
        return button;
      }
    }
    
    return null;
  };

  kviq.removeVippsButton = function (identifier) {
    if (kviq.vipps_buttons[identifier]) {
      var buttonData = kviq.vipps_buttons[identifier];
      
      if (buttonData.button && buttonData.button.parentNode) {
        buttonData.button.parentNode.removeChild(buttonData.button);
      }
      
      if (buttonData.br && buttonData.br.parentNode) {
        buttonData.br.parentNode.removeChild(buttonData.br);
      }
      
      delete kviq.vipps_buttons[identifier];
    }
  };

  kviq.handleAutobuy = function (targetButton) {
            history.pushState('', document.title, window.location.pathname);
    var autobuySpan = document.createElement('SPAN');
    autobuySpan.setAttribute('id', '_kviq_ec');
    targetButton.parentNode.appendChild(autobuySpan);
    autobuySpan.click();
  };

  kviq.createVippsButton = function (targetButton, formType) {
    var vippsButton = targetButton.cloneNode(true);
    
    vippsButton.type = 'button';
    vippsButton.setAttribute('id', '_kviq_ec');
    vippsButton.setAttribute('name', '');
    vippsButton.setAttribute('data-kviq-type', formType);
    
    var classWithoutAddToCart = vippsButton.className.replace(/(^| )js\-product\-button\-add\-to\-cart($| )/g, '');
    vippsButton.setAttribute('class', classWithoutAddToCart);
    
    return vippsButton;
  };

  kviq.styleVippsButton = function (vippsButton, targetButton, formType) {
    vippsButton.style.marginTop = '20px';
    vippsButton.style.border = '0px';
    vippsButton.style.backgroundColor = '#F15C2E';
    vippsButton.style.color = '#FFFFFF';
    vippsButton.style.textAlign = 'center';
    vippsButton.style.minHeight = '44px';
    
    vippsButton.innerHTML = "<img src='https://s.kviq.no/img/vipps_logo_micro-plain.png' style='vertical-align: middle; margin-right: 6px; height: 18px' alt='Kviq Express Checkout' title='Kviq Express Checkout System (Vipps) - Kviq.no'>";
    
    if (formType === 'cart_drawer') {
      vippsButton.style.marginTop = '10px';
    }
    
    if ((vippsButton.offsetTop - targetButton.offsetTop) >= 80) {
      vippsButton.style.marginTop = '1px';
    }
  };

  kviq.insertVippsButton = function (targetButton, formType, identifier) {
    var br = document.createElement('BR');
    var vippsButton = kviq.createVippsButton(targetButton, formType);
    
    targetButton.parentNode.appendChild(br);
    targetButton.parentNode.appendChild(vippsButton);
    
    kviq.styleVippsButton(vippsButton, targetButton, formType);
    
    kviq.vipps_buttons[identifier] = {
      button: vippsButton,
      br: br,
      type: formType
    };
    
    if (formType === 'product') {
      kviq_checkout_button = vippsButton;
      kviq_checkout_br = br;
    }
  };

  kviq.processFormCheckoutButton = function (formData) {
    var form = formData.form;
    var formType = formData.type;
    var identifier = formData.identifier;
    
    if (!form || !formType || !identifier) {
      return false;
    }
    
    console.log('[kviq.js] Processing form:', {
      formType: formType,
      identifier: identifier,
      formId: form.getAttribute('id'),
      formAction: form.getAttribute('action')
    });
    
    if (kviq.vipps_buttons[identifier]) {
      var existingButton = kviq.vipps_buttons[identifier].button;
      if (existingButton && existingButton.parentNode) {
        // console.log('[kviq.js] Vipps button already exists for:', identifier);
        return true;
      }
      kviq.removeVippsButton(identifier);
    }
    
    var targetButton = kviq.findTargetButton(form, formType);
    
    if (!targetButton) {
      // console.log('[kviq.js] No target button found for:', formType);
      return false;
    }
    
    if (kviq_autobuy === true && formType === 'product') {
      kviq.handleAutobuy(targetButton);
    } else {
      // console.log('[kviq.js] Inserting Vipps button for:', formType);
      kviq.insertVippsButton(targetButton, formType, identifier);
    }
    
    return true;
  };

  kviq.processAllCheckoutButtons = function () {
    var targetForms = kviq.findAllTargetForms();
    var processedCount = 0;
    
    console.log('[kviq.js] Found target forms:', targetForms.length);

    if (targetForms.length === 0) {
      console.log(`[kviq.js] expected num of forms to process is 0, skipping`);
      return true;
    }
    
    for (var i = 0; i < targetForms.length; i++) {
      if (kviq.processFormCheckoutButton(targetForms[i])) {
        processedCount++;
      }
    }

    return processedCount > 0;
  };

  kviq.observeCartDrawer = function () {
    if (typeof MutationObserver === 'undefined') {
      return;
    }
    
    console.log('[kviq.js] Setting up cart drawer observer');
    
    var processTimeout = null;
    
    var observer = new MutationObserver(function (mutations) {
      var shouldProcess = false;
      var reason = '';
      
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        var target = mutation.target;
        
        if (target) {
          var targetClass = target.className || '';
          var targetId = target.id || '';
          var targetDataAttr = target.getAttribute ? target.getAttribute('data-products') : null;
          
          if (targetDataAttr !== null) {
            shouldProcess = true;
            reason = 'data-products attribute detected';
          }
          
          if (targetClass.match(/(drawer|cart-drawer)/i)) {
            shouldProcess = true;
            reason = 'drawer class detected: ' + targetClass;
          }
          
          if (targetId.match(/(CartDrawer|drawer)/i)) {
            shouldProcess = true;
            reason = 'drawer id detected: ' + targetId;
          }
          
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            var newClass = target.className || '';
            if (newClass.match(/is-open|drawer--open|active/i) && targetId.match(/drawer/i)) {
              shouldProcess = true;
              reason = 'drawer opened via class change';
            }
          }
        }
        
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          
          if (node.nodeType === 1) {
            var nodeClass = node.className || '';
            var nodeId = node.id || '';
            
            if (nodeClass.match(/(drawer|cart-drawer|mini-cart|side-cart|cart__items|cart__checkout)/i) || 
                nodeId.match(/(drawer|cart-drawer|mini-cart|side-cart|CartDrawer)/i)) {
              shouldProcess = true;
              reason = 'cart/drawer node added: ' + (nodeId || nodeClass);
            }
          }
        }
      }
      
      if (shouldProcess) {
        console.log('[kviq.js] Cart drawer mutation detected:', reason);
        
        if (processTimeout) {
          clearTimeout(processTimeout);
        }
        
        processTimeout = setTimeout(function () {
          kviq.processAllCheckoutButtons();
        }, 150);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  };

  kviq.gen_checkout_button = function (attempts) {
    attempts = attempts || 0;
    
    var shopifyInterval = setInterval(function () {
      var success = kviq.processAllCheckoutButtons();
      
      if (success && attempts >= 1) {
        clearInterval(shopifyInterval);
      }
    }, 200);

    if (attempts < 2) {
      setTimeout(function () {
        clearInterval(shopifyInterval);
        kviq.gen_checkout_button(attempts + 1);
      }, 1000);
    }
    
    if (attempts === 0) {
      kviq.observeCartDrawer();
  }
  };
}

// Submit
kviq.submit_form = function (id, form) {

  var msn = form.msn.value.replace(/[^0-9]/g, '');

// ID = 3 ( Pincode )
  if (id == 3) {

    var pincode = form.pincode.value.replace(/[^0-9]/g, '');
    var order = form.order.value;
    var m = form.m.value;

    if (!msn.match(/^[49]\d{7}$/)) {
      kviq.info_popupbox("Informasjon", "Ugyldig mobilnummer");

    } else if (order.length < 1) {
      kviq.info_popupbox("Informasjon", "Ugyldig ordre");

    } else if (pincode.length != 4) {
      kviq.info_popupbox("Informasjon", "Ugyldig PIN-kode.");

    } else {
      var url = "https://s.kviq.no/ts/v";
      var parameters = "msn=" + msn + "&pincode=" + pincode + "&token_m=" + m + "&nid=" + kviq.net_id + "&order=" + order + "&token_i=" + kviq.cookie_main + "&ua=" + encodeURI(navigator.userAgent) + "&url=" + encodeURI(kviq.page_url);
      kviq.ajax(url, parameters, kviq.submit_response, 3);
    }

    return false;

// ID = 9 ( Order not paid )
  } else if (id == 9) {

    // Delete order
    if (form.kviq_delete.value == 1) {
      var url = "https://s.kviq.no/ts/d";
      var parameters = "msn=" + msn + "&o=" + form.o.value + "&t=" + form.t.value + "&token_i=" + kviq.cookie_main + "&ua=" + encodeURI(navigator.userAgent) + "&url=" + encodeURI(kviq.pathname_full);
      kviq.ajax(url, parameters, kviq.submit_response, 20);

      // Pay order
    } else {
      var url = "https://s.kviq.no/ts/p";
      var parameters = "msn=" + msn + "&o=" + form.o.value + "&t=" + form.t.value + "&token_i=" + kviq.cookie_main + "&ua=" + encodeURI(navigator.userAgent) + "&url=" + encodeURI(kviq.pathname_full);
      kviq.ajax(url, parameters, kviq.submit_response, 2);
    }
    return false;

// ID = 10 ( Address )
  } else if (id == 10) {

    if (msn.match(/^[49]\d{7}$/)) {
      var oid = form.o.value;
      var msn = form.msn.value;
      var t = form.t.value;
      var remember = (form.remember.checked ? 1 : 0);
      var firstname = form.firstname.value;
      var lastname = form.lastname.value;
      var street = form.street.value;
      var zipcode = form.zipcode.value;
      var place = form.place.value;
      var email = form.email.value;

      var parameters = "nid=" + kviq.net_id + "&msn=" + msn + "&token_i=" + kviq.cookie_main + "&t=" + t + "&o=" + oid + "&remember=" + remember + "&firstname=" + encodeURI(firstname) + "&lastname=" + encodeURI(lastname) + "&street=" + encodeURI(street) + "&zipcode=" + encodeURI(zipcode) + "&place=" + encodeURI(place) + "&email=" + encodeURI(email);
      var url = "https://s.kviq.no/ts/2";
      kviq.ajax(url, parameters, kviq.submit_response, 11);

    } else {
      kviq.info_popupbox("Informasjon", "Ugyldig mobilnummer.");
    }
    return false;

  }

}

// Respone
kviq.submit_response = function (id, response) {

// ID = 2
  if (id == 2) {
    if (obj = JSON.parse(response.responseText)) {
      if (obj.response_status == 0) {

        // If need pincode
        if (obj.msn) {
          document.getElementById('_kviq_ts-div-i').innerHTML = obj.div;
          kviq.adjust_div('ts');

          // If need pincode
//	        } else if ( obj.type && obj.type == 'sf' ){
//		    console.log( obj );

          // Redirect to Vipps
        } else {
//		    window.top.location.href = obj.url;
          window.top.location.href = 'https://s.kviq.no/redir/' + obj.url;
        }
      } else if (obj.response_status != 60) {
        kviq.info_popupbox('Informasjon', obj.response_text);
      }
    }

// ID = 3
  } else if (id == 3) {
    if (obj = JSON.parse(response.responseText)) {
      if (obj.response_status == 0) {
        var msn = obj.msn.replace(/[^0-9]/g, '');
        if (msn.match(/^[49]\d{7}$/)) {
          var order = '[' + obj.order + ']';
          var url = "https://s.kviq.no/ts/1";
          var parameters = "msn=" + msn + "&nid=" + kviq.net_id + "&order=" + order + "&token_i=" + kviq.cookie_main + "&ua=" + encodeURI(navigator.userAgent) + "&url=" + encodeURI(kviq.pathname_full);
          kviq.ajax(url, parameters, kviq.submit_response, 2);

        } else {
          kviq.info_popupbox("Informasjon", "Ugyldig mobilnummer.");
        }
        return false;
      } else if (obj.response_status == 13) {
        kviq.info_popupbox("Informasjon", "Feil pinkode.");
      }
    }

// ID = 10
  } else if (id == 10) {
    if (obj = JSON.parse(response.responseText)) {
      if (obj.response_status == 0) {

        // Redirect browser
        if (obj.url && obj.url.match(/^https:\/\//)) {
          window.top.location.href = 'https://s.kviq.no/redir/' + obj.url;

          // Replace DIV
        } else {
//		    document.body.innerHTML = obj.div + kviq.innerhtml;
          kviq.add_container(obj.div);

          document.getElementById('_kviq_ts-container').style.zIndex = kviq.find_highest_zindex("*");
          document.getElementById('_kviq_ts-div').style.zIndex = kviq.find_highest_zindex("*");

          kviq.adjust_div('ts');
        }
      }
    }

// ID = 11
  } else if (id == 11) {
    if (obj = JSON.parse(response.responseText)) {
      if (obj.response_status == 0) {
        kviq.close_container('ts')
        kviq.info_popupbox("Informasjon", obj.response_text);
      } else if (obj.response_status == 82) {
        kviq.info_popupbox("Informasjon", "Kan ikke lagre fordi adresseskjemaet er mangelfullt.");
      } else {
        kviq.info_popupbox("Informasjon", "Beklager, adressen ble ikke lagret (Feilkode: " + obj.response_status + ").");
      }
    }

// ID = 15
  } else if (id == 15) {
    if (obj = JSON.parse(response.responseText)) {
      if (obj.response_status == 0) {
        document.getElementById('kviq.form').firstname.value = obj.info.firstname;
        document.getElementById('kviq.form').lastname.value = obj.info.lastname;
        document.getElementById('kviq.form').street.value = obj.info.street;
        document.getElementById('kviq.form').zipcode.value = obj.info.zipcode;
        document.getElementById('kviq.form').place.value = obj.info.place;
      } else {
        kviq.info_popupbox("Informasjon", "Beklager, informasjon om eier ikke funnet.");
      }
    }

// ID = 16
  } else if (id == 16) {
    if (obj = JSON.parse(response.responseText)) {
      if (obj.response_status == 0) {
        document.getElementById('kviq.place').value = obj.geodata.place;
      } else {
        document.getElementById('kviq.place').value = '';
      }
    }

// ID = 21 ( Heartbeat )
  } else if (id == 21) {
    if (obj = JSON.parse(response.responseText)) {
      if (obj.response_status == 0) {


        // If order delivered
        if (obj.status == 10) {
          top.location.reload();

          // If order paid
        } else if (obj.status == 5 && obj.url) {
          // Stop heartbeat
          clearInterval(kviq.heartbeat_handle);
          
          if (typeof vipps_purchase_completed === 'function') {
            const orderData = {
              oid: kviq.oid,
              url: obj.url,
              status: obj.status,
              total_amount: obj.total_amount,
              variant_id: kviq.variant_id || null
            };
            vipps_purchase_completed(orderData);
          } else if (obj.url.length >= 12) {
            window.top.location.href = 'https://s.kviq.no/redir/' + obj.url;
          }

          // If order do not exists
        } else if (obj.status == -1) {
          top.location.reload();
        }
      }
    }

// ID = 90 ( Cart reset )
  } else if (id == 90) {
  }
}

// Popup if oid not empty
kviq.popup_sf = function (oid, msn) {
  if (oid != '' && msn.match(/^[49]\d{7}$/)) {
    // Show the address popup box
    var url = "https://s.kviq.no/ts/u";
    var parameters = "msn=" + msn + "&token_i=" + kviq.cookie_main + "&o=" + oid;
    kviq.ajax(url, parameters, kviq.submit_response, 10);
  }
}

// Heartbeat
kviq.heartbeat_sf = function (id) {

  // Run heartbeat code
  if (kviq.heartbeat_counter < kviq.heartbeat_looplimit) {
    if (id && id != '') {
      var url = "https://s.kviq.no/sf/h";
      var parameters = "id=" + id + "&token_i=" + kviq.cookie_main + "&url=" + encodeURI(window.location.href);
      kviq.ajax(url, parameters, kviq.submit_response, 21);
    }
    kviq.heartbeat_counter++;

    // Limit number of loops for heartbeat
  } else {
    clearInterval(kviq.heartbeat_handle);
  }
}// FOOTER //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

kviq._2201sf();
